<div class="d-flex flex-column justify-content-center align-items-center h-100 w-100 p-4">
  <cds-icon [shape]="icon()" size="large" class="p-4 rounded-icon rounded-circle mb-4"></cds-icon>
  <h4 class="fw-semibold" i18n>{{ title() }}</h4>
  <ng-content></ng-content>
</div>
